// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qAVw","selected":"styles_selected__hRG4y"};